import { parseTkLiteral, TK_ID_ATTR, TK_MARKER_SELECTOR } from '@ws/shared/utils';

export interface ITkMarkerTarget {
  id: string | null;
  ordinal: number;
}

/**
 * Находит элемент метки внутри контейнера конкретной заметки.
 *
 * `id` НЕ подставляется в селектор: значение приходит из содержимого заметки,
 * править которое может кто угодно, в том числе LLM через MCP. Интерполяция
 * дала бы в лучшем случае исключение, в худшем — обращение не к тому узлу.
 * Сравниваем значения атрибутов.
 *
 * Откат на порядковый номер считает ТОЛЬКО валидные метки: в «Ленте» содержимое
 * рендерится сырым, поэтому в DOM попадают и битые span, которых нет в списке.
 * Наивная нумерация увела бы не к той метке.
 */
export function findMarkerElement(
  container: HTMLElement,
  target: ITkMarkerTarget,
): HTMLElement | null {
  const valid = Array.from(container.querySelectorAll<HTMLElement>(TK_MARKER_SELECTOR)).filter(
    (element) => parseTkLiteral(element.textContent ?? ''),
  );

  if (target.id) {
    const byId = valid.filter((element) => element.getAttribute(TK_ID_ATTR) === target.id);

    // Ровно одно совпадение — это и есть та метка. Ноль или несколько означают,
    // что id не помог: уникальность id — лучшее усилие, а не инвариант.
    if (byId.length === 1) {
      return byId[0];
    }
  }

  return valid[target.ordinal] ?? null;
}
